import {
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_UNAUTHENTICATED,
  LOADER_FALSE,
  LOADING_DATA,
  VISITOR_LIST,
  VISITOR_VIEW,
  VISITOR_I,
  LOADER_CHECK,
  ROLE_MANAGEMENT_LIST,
} from '../type';
import axios from 'axios';
import { toast } from 'react-toastify';
import $ from 'jquery';

export const roleList = chartType => dispatch => {
  dispatch({ type: LOADING_UI });

  axios
    .post(
      `${process.env.REACT_APP_API_URL}userRoles/getAllRolesByOrg/`,
      chartType,
    )
    .then(res => {
     
      if (res.status === 200) {
        dispatch({ type: ROLE_MANAGEMENT_LIST, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADING_DATA });
        dispatch({ type: LOADER_CHECK });

        // $('.close').click();

        // toast.success(res.data.message, {
        // 
        // });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
          
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: LOADER_FALSE });
    });
};
export const CheckLoader = () => (dispatch) => {
  dispatch({ type: LOADER_FALSE });
}
